// (c) 2023 ABBYY Development, Inc.

export const LOGS_QUERY_KEY = 'LOGS';
export const LOG_QUERY_KEY = 'LOG';

export const TEMPLATES_QUERY_KEY = 'TEMPLATES';
export const TEMPLATE_QUERY_KEY = 'TEMPLATE';

export const TRANSFORMATIONS_QUERY_KEY = 'TRANSFORMATIONS';
export const TRANSFORMATIONS_COUNT_QUERY_KEY = 'TRANSFORMATIONS_COUNT';

export const RECORDERS_QUERY_KEY = 'RECORDERS';

export const AGENTS_QUERY_KEY = 'AGENTS';

export const TIMELINE_CONNECTION_QUERY_KEY = 'TIMELINE_CONNECTION';
export const OBFUSCATION_ENABLED_QUERY_KEY = 'OBFUSCATION_ENABLED';
export const ABOUT_QUERY_KEY = 'ABOUT';
export const DISCLOSE_OPERATOR_ENABLED_QUERY_KEY =
    'DISCLOSE_OPERATOR_ENABLED_QUERY_KEY';
export const EXPORT_OPERATOR_ENABLED_QUERY_KEY =
    'EXPORT_OPERATOR_ENABLED_QUERY_KEY';
export const EXPORT_HOST_ENABLED_QUERY_KEY = 'EXPORT_HOST_ENABLED_QUERY_KEY';

export const USER_QUERY_KEY = 'USER_QUERY_KEY';
export const IS_ADMIN_QUERY_KEY = 'IS_ADMIN_QUERY_KEY';
